module.exports = __webpack_public_path__ + "img/selbsterfahrung_640.9f902e44.webp";